<!-- 电费充值 -->
<template>
    <div class="toUpElectricCharge">

        <!-- 电表详情 -->
        <div class="electricitydetails" v-if="electricityForm != null">
            <div class="electricitydetailsFormBox">
                <div class="moneyBox">
                    <div class="labelBox">当前电费（元）</div>
                    <div class="moneyCenterBox CenterBox">
                        {{ electricityForm.money }}
                    </div>
                </div>
                <div class="electricityKWBox">
                    <div class="labelBox">当前读数（KW）</div>
                    <div class="kwCenterBox CenterBox">
                        {{ electricityForm.electricityKW }}
                    </div>
                </div>
            </div>
            <div class="toUpMoneyBtnBox" @click="playBtn">立即支付</div>

        </div>
        <!-- 各月/日 用电情况：表格 -->
        <div class="tableBox" v-if="electricityForm != null">
            <div class="tabBox">
                <div :class="tabIndex == item.value ? 'bordetBotoom' : ''" v-for="(item, key) in tabList" :key="key"
                    @click="tabChange(item)">
                    <div>{{ item.label }}</div>
                </div>
            </div>
            <div class="tableTd">
                <div v-for="(item, key) in tableTd" :key="key">{{ item.label }}</div>
            </div>

            <div :class="key % 2 == 0 ? 'bcc' : ''" class="tableTr" v-for="(item, key) in electricityForm.row"
                :key="key">
                <div>{{ item.time }}</div>
                <div>{{ item.initial }}</div>
                <div>{{ item.end }}</div>
                <div>{{ item.difference }}</div>
                <div>{{ item.money }}</div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {

            tabList: [
                { label: '日用量查询', value: '10' },
                { label: '月用量查询', value: '20' },
            ],
            tabIndex: '10',
            tableTd: [
                { label: '时间' },
                { label: '初始电量' },
                { label: '最后电量' },
                { label: '差值' },
                { label: '电费' }
            ],
            // 电表数据
            electricityForm: null
        }
    },
    created() { },
    mounted() {
        this.setData()
    },
    methods: {
        playBtn() {
            this.$router.push({ path: './playElectricityBill' })
        },
        setData() {
            // let data = {
            //     openId: this.openId,
            //     oldCardNumber: this.carForm.oldCarNum,
            //     newCardNumber: this.carForm.newCarNum,
            // }
            // this.$axios.post('/lockapi/smartlock/input-newcardnumber', data).then(res => {
            //     if (res.data.success) {
            //         this.status = 2
            //     } else {
            //         this.$toast.fail('提交失败,原因：' + res.data.msg + '!')
            //     }
            // }).catch(error => {
            //     this.$toast.fail('提交失败!')
            // })
            this.electricityForm = {
                money: '10.0',
                electricityKW: '10.28',
                row: [
                    {
                        time: '2020-06-14',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06-14',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06-14',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06-14',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06-14',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                ]
            }
        },
        tabChange(item) {
            this.tabIndex = item.value
            this.electricityForm = {
                money: '10.0',
                electricityKW: '10.28',
                row: [
                    {
                        time: '2020-06',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                    {
                        time: '2020-06',
                        initial: '100.0',
                        end: '110.0',
                        difference: '10.0',
                        money: '9.60'
                    },
                ]

            }


        },

    }
}
</script>

<style lang="less" scoped>
.toUpElectricCharge {


    .electricitydetails {
        margin: 0.5rem 0;
        padding: 0.5rem;
        background-color: #fff;

        .electricitydetailsFormBox {
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 1.5rem;
            padding: 0 0 0 1rem;

            >div {
                flex: 1;
                text-align: left;
            }

            .labelBox {
                font-size: 0.55rem;
            }

            .CenterBox {
                font-size: 0.9rem;
            }

            .moneyCenterBox {
                color: orange;
            }

            .kwCenterBox {
                color: rgb(64, 134, 240);
            }
        }

        .toUpMoneyBtnBox {
            width: 8rem;
            height: 1.2rem;
            line-height: 1.2rem;
            margin: 1rem auto 0.2rem;
            background-color: rgb(81, 199, 81);
            border-radius: 0.6rem;
            color: #fff;
            text-align: center;
        }


    }

    .tableBox {
        line-height: 1rem;
        background-color: #fff;
        margin-top: 1rem;
        padding: 0.5rem;

        .tabBox {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 1.5rem 0.8rem;

            >div {
                flex: 1;
                font-size: 0.55rem;
                line-height: 1.5rem;

            }
        }

        .bordetBotoom {
            border-bottom: 1px solid rgb(64, 134, 240);
        }

        .tableTd {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.5rem;
            font-weight: 700;

            >div {
                flex: 1;
            }
        }

        .tableTr {
            display: flex;
            justify-content: start;
            font-size: 0.5rem;

            >div {
                flex: 1;
            }

        }

        .bcc {
            background-color: #eee;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/electricCharge/toUpElectricCharge.vue